// extracted by mini-css-extract-plugin
export default {"menu":"menu--1oX7j","menu__icon":"menu__icon--13pFO","menu__content":"menu__content--AHag7","menu__content--grey":"menu__content--grey--1icVf","menu__bottom__left":"menu__bottom__left--3tAp3","menu__bottom__right":"menu__bottom__right--24NAy","menu__top__left":"menu__top__left--1xoKb","menu__top__right":"menu__top__right--1ReVR","menu__button":"menu__button--jLARy","menu__separator":"menu__separator--3rgCv"};
    if(module.hot) {
      // 1747648162465
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  